import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'org-details',
})

export default class OrgDetails extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private sourceId: any;

    private  filter: any = null;

    private orgsDetails: any = [];

    private orgsFields: any = [
        {
            key: 'sourcedId',
            label: 'Sourced Id',
        },
        {
            key: 'name',
            label: 'Name',
        },
    ];

    // ---------------------------------------------------------------------------------
    // Hooks



    // ------------------------------------------------------------------------------
    // Methods


}
